<template>
    <main v-if="$store.getters.USERPROFILE['product-administration']">
        <section class="whiteBox">
            <div class="content">
                <h1>{{$t('createProduct.title')}}</h1>
            </div>
            <hr>
            <div class="content">
                    <label>{{$t('createProduct.productCode')}}</label>
                    <div class="row">
                        <div class="demiRow">
                        <input type="text" v-model="product['merchant-reference']" />
                        </div>
                        <p class="tips">{{$t('createProduct.productCodeUsedBy')}}</p>
                    </div>
                    <label>{{$t('products.productName')}}</label>
                    <div class="row">
                        <div class="demiRow">
                        <input type="text" v-model="product.name"/>
                        </div>
                        <p class="tips">{{$t('createProduct.usedToFindProduct')}}</p>
                    </div>
                    <label>{{$t('createProduct.salesChannel')}}</label>
                    <div class="row">
                        <div class="demiRow">
                        <select v-model="product['channel-id']">
                            <option 
                                v-for="channel in salesChannels" :key="channel.id"
                                :value="channel.id"
                            >
                                {{channel['name']}}  ({{channel['merchant-name']}})
                            </option>
                        </select>
                        </div>
                        <p class="tips">
                            {{$t('createProduct.selectOrCreateSalesChannel')}}
                        </p>
                    </div>
                <br>
                <a @click="show.modal = true">{{$t('createProduct.newSalesChannel')}}</a>
                <Add v-if="show.modal" @close="show.modal = false" @get="getSalesChannels" @newchannel="selectNewChannel"></Add> 
                <div class="spacer"></div>
                <hr><br>
                <div class="row">
                    <button @click="addProduct()">{{$t('button.createTheProduct')}}</button>
                    <a @click="goBack()">{{$t('button.cancel')}}</a>
                </div>
            </div>
        </section>
    </main>
    <main v-else>
        <NoAccess></NoAccess>
    </main>
</template>

<script>
    import Products from '@/services/Products.js'
    import SalesChannels from '@/services/SalesChannels.js'
    import Add from '@/components/salesChannel/Add'
    import NoAccess from '@/components/layout/NoAccess'
    export default {
        components: { Add, NoAccess },
        data () {
            return {
                salesChannels: [],
                product: {
                    'id': '',
                    'name': '',
                    'merchant-reference': '',
                    'channel-id': '',
                    'archived': 'false',
                },
                show: {
                    modal: false,
                }
             }
        },
        mounted () {
            this.getSalesChannels()
        },
        methods: {
            getSalesChannels() {
                SalesChannels.getSalesChannels().then(res => {
                    this.salesChannels = res
                })
            },
            selectNewChannel(data) {
                this.product['channel-id'] = data['id']
            },
            addProduct() {
                Products.add(this.product).then(res => {
                   if (res.status === 201) {
                        this.$router.push('/products') 
                    }
                    // controle a faire avec message erreur 
                    // si erreur cote serveur
                })
            },
            goBack(){
                window.history.go(-1)
            }
        }
    }
</script>